import { render, staticRenderFns } from "./partner-contract.vue?vue&type=template&id=12c4054c"
import script from "./partner-contract.vue?vue&type=script&lang=js"
export * from "./partner-contract.vue?vue&type=script&lang=js"
import style0 from "./partner-contract.vue?vue&type=style&index=0&id=12c4054c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports